import ErrorStackParser from 'error-stack-parser';

const onceAndDebug = (original: (...args: Array<any>) => any) => {
  let hasFired = false;
  let cachedValue: any = null;

  const prevCall = ErrorStackParser.parse(Error(''))[1] || {
    functionName: '<unknown>',
  };

  return (...args: Array<any>) => {
    if (hasFired) {
      console.warn('Function silenced', prevCall);
      return cachedValue;
    }

    hasFired = true;
    cachedValue = original(...args);
    return cachedValue;
  };
};

export default onceAndDebug;
